import { TFunction } from 'i18next';

export const getGroupDisplayName = (
  group: { name: string; isDefault?: boolean | null },
  t: TFunction
): string =>
  group.isDefault || group.name === 'Kaikki' ? t('Group:defaultName') : group.name;
